import { gql } from "@apollo/client"

export const CREATE_FORM_MUTATION = gql`
    mutation CreateForm($record: CreateOneFormInput!) {
        createForm(record: $record) {
            recordId
            record {
                completed
            }
        }
    }
`
